module.exports = __webpack_public_path__ + "img/hyl2_title.39119102.png";